"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNewAttackerFacingAway = void 0;
const direction_1 = require("./direction");
const getNewAttackerFacingAway = (oldFacingAway, direction) => {
    if (direction === direction_1.Directions.LEFT || direction === direction_1.Directions.RIGHT) {
        // if it's left or right we don't need to change it
        return oldFacingAway;
    }
    if (direction === direction_1.Directions.UP) {
        return true;
    }
    return false;
};
exports.getNewAttackerFacingAway = getNewAttackerFacingAway;
